"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.61 10.57-.78-1.15a1 1 0 0 0 -1.39-.27 1 1 0 0 0 -.27 1.38l2.83 4.15a1 1 0 0 0 1.59.08l3.21-3.83a1 1 0 1 0 -1.58-1.28l-1.71 2a7.83 7.83 0 0 1 2.71-5.6l-1.07-1.72a10 10 0 0 0 -3.54 6.24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m10.56 4.32a7.53 7.53 0 0 1 7.35 2.33 1 1 0 1 0 1.49-1.32 9.47 9.47 0 0 0 -9.3-2.95 9.8 9.8 0 0 0 -1.36.43l1.09 1.75c.24-.08.48-.18.73-.24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.44 20a7.53 7.53 0 0 1 -7.35-2.33 1 1 0 1 0 -1.49 1.33 9.47 9.47 0 0 0 9.3 2.94 9.61 9.61 0 0 0 2.61-1l-1.07-1.71a8 8 0 0 1 -2 .77z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.83 13.75-2.83-4.14a1 1 0 0 0 -1.59-.09l-3.21 3.84a1 1 0 0 0 .13 1.4 1 1 0 0 0 1.41-.12l1.71-2.05a7.76 7.76 0 0 1 -1.73 4.63l1.15 1.78a9.89 9.89 0 0 0 2.52-5.28l.78 1.16a1 1 0 1 0 1.66-1.12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.45 22.49-2.07-3.31-1.09-1.74-7.99-12.76-1.06-1.68-1.58-2.54a1 1 0 0 0 -1.66 1.05l1.53 2.49 1.07 1.69 8.17 13 1.05 1.68 1.95 3.12a1 1 0 0 0 .82.46 1 1 0 0 0 .86-1.51z"
  })));
};

exports["default"] = _default;